/* eslint-disable unicorn/prefer-export-from */
import IndicatorChart from 'components/IndicatorChart/IndicatorChart';

export default IndicatorChart;
